import { render, staticRenderFns } from "./CourseVideoLink.vue?vue&type=template&id=c4d03ddc&scoped=true&"
import script from "./CourseVideoLink.vue?vue&type=script&lang=js&"
export * from "./CourseVideoLink.vue?vue&type=script&lang=js&"
import style0 from "./CourseVideoLink.vue?vue&type=style&index=0&id=c4d03ddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d03ddc",
  null
  
)

export default component.exports